import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Button, Grid2, TextField } from "@mui/material";
import { buildIRI } from "../../../utils/function";
import { DataService } from "../../../services/DataService";
import { useEffect } from "react";
import { _ACTIONS } from "../../../utils/constants";
import { _ROUTER_DOM_URL, _ROUTES } from "../../../utils/_routes_constants";
import { createToast } from "../../../utils/toast";
import { useNavigate } from "react-router-dom";
import { CallMissedOutgoing } from "@mui/icons-material";

export const AvgPriceValue = ({
  params,
  inputBlockData,
  setInputBlockData,
}) => {
  const dataService = new DataService();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      externalPrice: 0,
      internalPrice: 0,
      site: buildIRI("/sites", params.site),
      version: params.version,
      fiscalYear: params.fiscalYear,
    },
    validationSchema: Yup.object().shape({
      site: Yup.string(),
      externalPrice: Yup.number()
        .typeError("External price must be a number")
        .required("External price is required")
        .test(
          "is-decimal",
          "External price must be a valid number with up to 2 decimal places",
          (value) => /^\d+(\.\d{1,2})?$/.test(value),
        ),
      internalPrice: Yup.number()
        .typeError("Internal price must be a number")
        .required("Internal price is required")
        .test(
          "is-decimal",
          "Internal price must be a valid number with up to 2 decimal places",
          (value) => /^\d+(\.\d{1,2})?$/.test(value),
        ),
    }),
    onSubmit: (values) => {
      const method = inputBlockData ? _ACTIONS.PATCH : _ACTIONS.POST;
      const url = inputBlockData
        ? _ROUTES.INPUT_SALE_BLOCKS + "/" + inputBlockData.id
        : _ROUTES.INPUT_SALE_BLOCKS;

      dataService.doRequest(
        method,
        url,
        {
          ...values,
          site: buildIRI("/sites", params.site),
          version: params.version,
          fiscalYear: params.fiscalYear,
        },
        {},
        async (data) => {
          const response = await data.json();

          setInputBlockData(response);
          createToast("success", "Data saved successfully");
        },
      );
    },
  });

  useEffect(() => {
    dataService.fetchData(
      _ROUTES.INPUT_SALE_BLOCKS,
      {
        site: params.site,
        version: params.version,
        fiscalYear: params.fiscalYear,
      },
      (data) => {
        if (data) {
          formik.setValues({
            externalPrice: data?.[0]?.externalPrice || 0.0,
            internalPrice: data?.[0]?.internalPrice || 0.0,
          });

          setInputBlockData(data?.[0] || null);
        }
      },
    );
  }, [params]);

  return (
    <>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            color="success"
            variant="contained"
            size="small"
            onClick={() => navigate(_ROUTER_DOM_URL.BUDGET_INPUT_RATE_INCREASE)}
            endIcon={<CallMissedOutgoing />}
          >
            See increase
          </Button>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <Grid2 container spacing={2} display="flex" justifyContent="flex-end">
            <Grid2 size={{ xs: 6, md: 4 }}>
              <TextField
                id="externalPrice"
                name="externalPrice"
                label="External Price"
                type="number"
                value={formik.values.externalPrice}
                onChange={formik.handleChange}
                error={
                  formik.touched.externalPrice &&
                  Boolean(formik.errors.externalPrice)
                }
                helperText={
                  formik.touched.externalPrice && formik.errors.externalPrice
                }
                fullWidth
                size="small"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 4 }}>
              <TextField
                id="internalPrice"
                name="internalPrice"
                label="Internal Price"
                type="number"
                value={formik.values.internalPrice}
                onChange={formik.handleChange}
                error={
                  formik.touched.internalPrice &&
                  Boolean(formik.errors.internalPrice)
                }
                helperText={
                  formik.touched.internalPrice && formik.errors.internalPrice
                }
                fullWidth
                size="small"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 2 }}>
              <Button type="submit" variant="contained" color="success">
                Save
              </Button>
            </Grid2>
          </Grid2>
        </form>
      </Box>
    </>
  );
};
